import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { TaskConsolidateViewDialog } from '../../components/TaskConsolidateViewDialog';
import { AppHelper } from '../../helpers/AppHelper';
import { taskStateOptions } from '../../data/data';
import { SearchBar } from '../../common/components/SearchBar';
import { MultiSelectDropDown } from '../../common/components/MultiSelectDropDown';
import moment from 'moment';
import { VenueSummary } from '../../components/VenueSummary';

export class Tasks extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = this.props.match.params.id ? 'VenueTasks' : 'Tasks'
    this.pageTitle = Helper.getString('tasks')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.defaultState = '_ALL'
    const qParams = { pb: 'fieldDef,fieldDefSubtask', state: this.defaultState, limit: 100 }
    if (this.props.match.params.id) {
      this.venueCode = this.props.match.params.id
      qParams.venueCode = this.venueCode
      this.pageTitle = Helper.getString('tasks') + ': ' + this.venueCode
    }
    this.toFetch = [
      { method: 'GET', paths: ['miscs','installertasks-cms'], queryParams: qParams },
      { method: 'GET', paths: ['users'], queryParams: { orgId: this.orgId, pb: 'fieldDef' } }
    ]
    if (this.options && this.venueCode) {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
        { title: Helper.getString('venues'), to: this.baseRoute() + '/screens'},
        { title: this.pageTitle },
      ]
    } else {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
        { title: this.pageTitle },
      ]
    }
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Task: (current) => {
        return (
          <Fragment>
            <div>{current.title}</div>
            <div className={css(Styles.infos)}>
              <div>{Helper.getString('subTask')} : {current.subtasks ? Object.keys(current.subtasks).length : 0} </div>
              {current.createdTs &&
                <div>{Helper.getString('createdOn')} : {Helper.formatTimestamp(current.createdTs)}</div>}
              {current.state === 'COMPLETED'  && current.completedTs &&
                <div>{Helper.getString('completedOn')} : {Helper.formatTimestamp(current.completedTs)}</div>}
              {current.state === 'REJECTED'  && current.rejectedTs &&
                <div>{Helper.getString('rejectedOn')} : {Helper.formatTimestamp(current.rejectedTs)}</div>}
            </div>
          </Fragment>
        )
      },
      DeviceCode: (current) => {
        return (<Fragment>
          <VenueSummary
            item={current}
            site={current.site}
            showVenueTitle={false}
            showArchived={false}
            showNotRegistered={false}
            showTesting={false}
            showExtId={false}
          />
        </Fragment>)
      },
      State: (current) => this.getChips(current.state)
    }
    if(this.options.pageForOrgType !== 'PARTNER') {
      this.tableHeadersMap.Assignee = (current) => {
        return this.getInstallerEmailById(current.assigneeId)
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.allowAccessToRoles = ['SUPERUSER']
    if(!UiHelper.isUserHasRoles(this.allowAccessToRoles)) {
      this.noAdd = true
    }
  }

  getChips = (state) => {
    switch (state) {
    case 'COMPLETED':
      return AppUiHelper.chipLive(state, true)
    case 'REJECTED':
      return AppUiHelper.chipError(state)
    case 'LIVE':
      return AppUiHelper.chipDisabled(state)
    case 'DRAFT':
      return AppUiHelper.chipDisabled(state)
    case 'ARCHIVED':
      return AppUiHelper.chipDisabled(state)
    default:
      return state
    }
  }
  // Populate user to options
  getInstallers(usersData) {
    // Check if user data is empty or not an array
    if (!usersData || !Array.isArray(usersData) || usersData.length === 0) {
      return [];
    }
    // Filter for users with the "INSTALLER" role and map to desired format
    return usersData
      .filter(user => user.roles && user.roles.includes('INSTALLER'))
      .map(user => ({
        id: user.userId,
        title: `${user.email}`,
        text:`${user.email}`,
        key: user.userId,
      }));
  }

  // Print email from id, on list
  getInstallerEmailById(userId) {
    const usersData = this.state.installerUsers || []
    const user = usersData.find(user => user.id === userId);
    return user ? user.title : null;
  }

  _changePaginationLimit() {
    if(this.toFetchNext && this.toFetchNext.queryParams && this.toFetchNext.queryParams.limit) this.toFetchNext.queryParams.limit = 500
  }

  onFetchSuccess(results, opts) {
    const { fetchNext } = opts || {}
    if(results[0]) this.handleNextpage(results[0])
    this._changePaginationLimit()
    if (fetchNext) {
      const updatedItems = this.state.items.concat(Helper.dictToArray(results[0].items))
      this.setState({
        items: updatedItems,
        nextPageState: ApiHelper.State.READY,
      })
      return
    }
    // Pagination -- ENDS
    this.formDefinition = results[0].fieldDef // Tasks
    const installerUsers = this.getInstallers(results[1].items) // Get Installer to options list
    UiHelper.populateOptions(this.formDefinition, { items: installerUsers }, 'assigneeId')
    // Subtask label
    const subtaskLists = results[0].fieldDefSubtask.steps[0].fields.find( x => x.key === 'iType')
    if (subtaskLists && subtaskLists.options) {
      this.subtaskLists = subtaskLists.options
    }
    this.handleNextpage(results[0])
    this._changePaginationLimit()
    this.setState({
      items: results[0].items,
      installerUsers: installerUsers,
      stateFilterValue: this.defaultState,
    })
    if(!this.venueCode) {
      this.export = {
        buttonTitle: 'Download',
        headers: {
          title: 'title',
          subtaskCount: 'subtaskCount',
          createdTs: 'createdOn',
          completedTs: 'completedOn',
          deviceCode: 'deviceCode',
          'site.title': 'siteTitle',
          'site.address': 'siteAddress',
          serialNumber: 'serialNumber',
          state: 'state',
          assigneeEmail: 'assigneeEmail',
          images: 'images'
        },
        format: 'xlsx'
      }
    }
  }

  makeFileName = () => {
    return 'tasks-dolphin-' + moment().format('MM-DD-YYYY_HH-mm-ss');
  }

  prepExcelDownload() {
    const rows = [];
    for (const item of this.state.items) {
      if(item.subtasks) {
        const imagesArray =
            Object.values(item.subtasks || {})
              .filter(task => task.iType === 'IMAGES' && Array.isArray(task.values))
              .flatMap(task => task.values) || [];
        item.images = (imagesArray || []).join(', ')
      }
      const e = {};
      for (const hKey in this.export.headers) {
        e[this.export.headers[hKey]] = this.exportRowItemValue(hKey, item)
      }
      rows.push(e);
    }
    return rows
  }

  exportRowItemValue(key, current) {
    const serialNumber = current.latestDeviceFeed && current.latestDeviceFeed.serialnumber
      ? current.latestDeviceFeed.serialnumber
      : current.serialNumber
    const site = current.site || {}

    switch (key) {
    case 'site.title':
      return site.title || ''
    case 'site.address':
      return site.address || ''
    case 'serialNumber':
      return serialNumber || ''
    case 'subtaskCount':
      return current.subtasks ? Object.keys(current.subtasks).length : 0
    case 'createdTs':
      return current.createdTs ? Helper.formatTimestamp(current.createdTs) : ''
    case 'completedTs':
      return current.completedTs ? Helper.formatTimestamp(current.completedTs) : ''
    case 'assigneeEmail':
      return this.getInstallerEmailById(current.assigneeId) || ''
    default:
      return super.exportRowItemValue(key, current)
    }
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  openModalForAdd(fieldDef) {
    this.formDefinition = fieldDef || this.fieldDef || this.formDefinition
    this.formDefinition.formType = 'add'
    Helper.deleteFormDefinitionValues(this.formDefinition)
    if ( this.venueCode && this.options && this.options.pageForOrgType !== 'PARTNER') {
      Helper.populateFormDefinitionValues(this.formDefinition, { deviceCode: this.venueCode })
    }
    this.onAdd();
    this.setState({
      modalOpen: true
    });
  }


  onAdd() {
    if ( this.venueCode && this.options && this.options.pageForOrgType !== 'PARTNER') {
      this.formDefinition.disableAlwaysFormFields = ['deviceCode']
    } else {
      delete this.formDefinition.disableAlwaysFormFields
    }
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['tasks']),
    });
  }

  onEdit(current) {
    this.formDefinition.steps[0].fields.find(i => i.key === 'deviceCode').disabled = true
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['tasks', current.id]),
    });
  }

  onActions(current) {
    const actions = []
    const { imgSubTasks, nonImgSubTasks } = AppHelper.processSubtasks({task: current})
    if(nonImgSubTasks.length > 0 || imgSubTasks.length > 0) UiHelper.addActionButtonByRole(actions, this.addSubtaskModalAction(this, current), this.allowAccessToRoles)
    if(!this.options || (this.options && this.options.pageForOrgType !== 'PARTNER')) {
      // UiHelper.addActionButtonByRole(actions, this.subTaskButton(current))
      UiHelper.addActionButtonByRole(actions, this.addSubtaskDetailsAction(this, current), this.allowAccessToRoles)
      UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    }

    return actions
  }

  addSubtaskDetailsAction(e, current) {
    return (
      <Tooltip title={Helper.getString('taskDetails')} placement='top-start' key={'adsPlayButton'}>
        <Link  to={this.baseRoute() + '/tasks/' + current.id} key={current.id + '-details'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>playlist_play</i>
          </span>
        </Link>
      </Tooltip>
    )
  }

  addSubtaskModalAction(e, current) {
    if(!current.subtasks || (current.subtasks && Object.keys(current.subtasks).length < 1)) return ''
    return (
      <Tooltip title={Helper.getString('preview')} placement='top-start' key={'adsPlayButton'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.displaySubtaskModal(current)}>visibility</i>
        </span>
      </Tooltip>
    )
  }

  getQueryParams() {
    const queryParams = { }

    if (this.state.searchText) {
      queryParams.query = this.state.searchText
    }
    if(this.state.installerUserIdToFilter) {
      queryParams.assigneeId = this.state.installerUserIdToFilter
    }
    if (this.state.stateFilterValue) {
      queryParams.state = this.state.stateFilterValue
    }queryParams.orgId = this.orgId;
    queryParams.pb = 'fieldDef,fieldDefSubtask';
    queryParams.limit = 100;
    if(this.venueCode) queryParams.venueCode = this.venueCode
    this.toFetch[0] = { method: 'GET', paths: ['miscs', 'installertasks-cms'], queryParams }
    console.log(this.toFetch[0])
    return queryParams
  }

  searchHandler() {
    ApiHelper.call(
      {
        method: 'GET', endPoint: ApiHelper.makeUrlPath(['miscs', 'installertasks-cms'], this.getQueryParams()),
      },
      function (err, data) {
        if (err) {
          this.emptyText = Helper.getErrorMsg(err)
          this.setState({
            errMsg: Helper.getErrorMsg(err),
            items: [],
            nextPage: '',
            inProcessSearch: false,
            inProcessOnList: false
          })
          return
        }
        this.emptyText = (
          <span className={css(Styles.emptyTextHolder)}>
            <span>{Helper.getString('noTask')}</span>
          </span>
        )
        this.handleNextpage(data)
        this._changePaginationLimit()
        this.setState({
          successMsg: '',
          items: data.items,
          errMsg: null,
          inProcessSearch: false,
          inProcessOnList: false
        })
      }.bind(this));
  }

  onList() {
    if(this.multiSelectDropDown) this.multiSelectDropDown.setState({value: null})
    if(this.searchBarComponent) this.searchBarComponent.setState({searchText:''})
    this.setState({ searchText: '', inProcessOnList: true, stateFilterValue: this.defaultState, installerUserIdToFilter: null }, () => this.searchHandler())
  }

  onSearch = (searchText) => {
    this.setState({ searchText: searchText, inProcessSearch: true }, () => { this.searchHandler() })
  }

  onStateFilter(e) {
    const selectedState = e.target.value
    this.setState({
      stateFilterValue:selectedState
    })
  }

  onEmailSelect(item) {
    this.setState({
      installerUserIdToFilter: item && item.id || null
    })
  }

  renderAboveTable() {
    return (
      <div className={css(Styles.aboveTable)}>
        {this.options.pageForOrgType !== 'PARTNER' &&
          <MultiSelectDropDown
            ref={(child) => (this.multiSelectDropDown = child)}
            options={this.state.installerUsers}
            placeHolder={'Select Assignee'}
            container={Styles.customContainer}
            onChange={this.onEmailSelect.bind(this)}
          />
        }
        <SearchBar
          ref={(child) => (this.searchBarComponent = child)}
          hint={'Search'}
          inProcessSearch={this.state.inProcessSearch || false}
          inProcessOnList={this.state.inProcessOnList || false}
          onList={this.onList.bind(this)}
          onSearch={this.onSearch.bind(this)}
          searchText={this.state.searchText}
          onSinglePickerFilter={this.onStateFilter.bind(this)}
          singleSelectPicker={
            {
              options: taskStateOptions,
              defaultValue: this.state.stateFilterValue,
              // title: 'Select State'
            }
          }
          showRecentButtonText={'Reset Filter'}
          pickerContainer={Styles.pickerContainer}/>
        <TaskConsolidateViewDialog
          isOpen={this.state.displaySubtaskDialog || false}
          title={this.state.modalTitle || ''}
          onClosed={() => { this.setState({ displaySubtaskDialog: false }) }}
          task={this.state.task || []}
          subtaskLabelMap={this.subtaskLists}
        ></TaskConsolidateViewDialog>

      </div>
    )
  }

  displaySubtaskModal(current) {
    this.setState({
      displaySubtaskDialog: true,
      modalTitle: current.title,
      task: current
    })
  }

  subTaskButton(current) {
    let path = this.baseRoute() + '/tasks/' + current.id + '/subtasks'
    if(this.venueCode) {
      path = path + '?venueCode=' + this.venueCode
    }
    return (
      <Link to={path} key={current.id + '-subtask'}>
        <Tooltip title={Helper.getString('subTask')} placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>playlist_play</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

}

const Styles = StyleSheet.create({
  infos:{
    display: 'flex',
    marginTop: 6,
    fontSize: 12,
    flexDirection: 'column'
  },
  customContainer: {
    marginBottom: 16,
  },
  aboveTable: {
    display: 'flex',
    flex: 1,
    gap: 10,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      gap:0
    }
  },
  line2: {
    fontSize: 12
  },
  storeNameText:{
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  pickerContainer: {
    flex: .5
  }
})



// WEBPACK FOOTER //
// ./src/screens/admin/Tasks.js